import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-cream-beige border-y border-gold-light" data-id="element-17" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-18" data-mp="22dit6h51bb2w">
        <div className="text-center mb-16" data-id="element-19" data-mp="1ydrxbz0ni4ri">
          <p className="text-navy-medium font-bold tracking-widest uppercase mb-2" data-id="element-20" data-mp="1yet6tz20qj74">
            Included with your purchase at no additional cost
          </p>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-navy" data-id="element-21" data-mp="15q5ly4l6lvu3">
            🎁 <span className="text-gold" data-id="element-22" data-mp="1jhanxdc0v07l">5 Professional Bonus Guides</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-23" data-mp="1epit2qlu28bn">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-cream-card border border-gold-light rounded-2xl p-8 shadow-sm relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-24" data-mp="qzy8k3a17309" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-navy text-gold px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-25" data-mp="2ogpry93t3xg4">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-cream-beige border border-gold-light rounded-full flex items-center justify-center text-gold mb-4" data-id="element-26" data-mp="1qvlf19cngbkq">
                <Gift size={24} data-id="element-27" data-mp="20qdb28ql2qde" />
              </div>
              <h3 className="text-xl font-serif font-bold mb-2 pr-28 text-navy" data-id="element-28" data-mp="20trd1fvc4xkb">{bonus.title}</h3>
              <p className="text-navy-medium text-sm italic mb-4 border-l-2 border-gold pl-4" data-id="element-29" data-mp="25o52z2r8achl">
                {bonus.subtitle}
              </p>
              <p className="text-ink text-sm mb-4 leading-relaxed" data-id="element-30" data-mp="3h4llx61zrb97">{bonus.intro}</p>
              <ul className="space-y-2 mb-6 flex-grow" data-id="element-31" data-mp="1h2vsaup25p26">
                {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-32" data-mp="1c53ph5mvkij7">
                    <CheckCircle2 size={16} className="text-emerald-brand shrink-0 mt-0.5" data-id="element-33" data-mp="1q43cy9ynirds" />
                    <span className="text-ink text-sm" data-id="element-34" data-mp="1m2i7vasczhe5">{bullet}</span>
                  </li>)}
              </ul>
              <p className="text-navy font-semibold text-sm italic mt-auto pt-4 border-t border-gold-light" data-id="element-35" data-mp="yc4cpbeh92fc">
                {bonus.closing}
              </p>
            </motion.article>)}
        </div>
      </div>
    </section>;
}